import {
  INICIALITZAR,
  OBTENIR_DADES_CREACIO_INDIVIDU
} from "../actions/actionTypes";

const ESTAT_INICIAL = {};

const regnes = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_SUCCESS`:
      return action.payload.regnes;
    default:
      return state;
  }
};

export default regnes;

const totsRegnes = state => state.regnes;

export const getRegnes = state => {
  const regnes = totsRegnes(state);

  if (!regnes) {
    return null;
  }
  return regnes;
};
